import axios from "axios";

export const getPoses = async (token) => {
  const apiUrl = `${process.env.REACT_APP_SERVER_URL}/poses`;
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching poses:", error);
    throw error;
  }
};

export const getPoseProgress = async (token) => {
  const apiUrl = `${process.env.REACT_APP_SERVER_URL}/poses/progress`;
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching pose progress:", error);
    throw error;
  }
};

export const recordPoseAnswer = async (token, sanskrit, correct) => {
  const apiUrl = `${process.env.REACT_APP_SERVER_URL}/poses/progress`;
  try {
    const response = await axios.post(
      apiUrl,
      { sanskrit, correct },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error recording pose answer:", error);
    throw error;
  }
};
